import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import { goTo } from "../tools";
import "./mi-perfil.css";
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';

const validacion = "VALIDACIÓN";
const ojitoCerrado = "eye-hidden";
const ojito = "eye-visible";

const mapState = (state) => {
    return {
        password: state.miPerfil.password,
        pasoEliminar: state.miPerfil.pasoEliminar,
        opcion: state.miPerfil.opcion
    };
}

const mapDispatch = (dispatch) => {
    return {
        guardarPassword: (pass) => {
            dispatch({ "type": "MI_PERFIL_GUARDAR_PASSWORD", "password": pass });
        },
        pasoAnterior: () => {
            dispatch({ "type": "MI_PERFIL_PASO_ANTERIOR_ELIMINAR" });
        },
    }
}

const onSubmitFail = (errors, dispatch, props) => {

}
const validate = values => {
    const errors = {}

    return errors
}


const campoSettings = {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 'normal',
    mixBlendMode: 'normal',
}

const floatingLabelStyleSettings = {
    ...campoSettings,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: '#0C2040',
}

const floatingLabelFocusStyleSettings = {
    ...campoSettings,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: '#FF6B0B',
}

const campo = ({ input, label, type, param, max, fnToggle, clase, error }) => {
    return (
        <MuiThemeProvider>
            <TextField
                {...input}
                floatingLabelText={label}
                fullWidth={true}
                underlineStyle={{ borderColor: '#AAC3EE' }}
                underlineFocusStyle={{ borderColor: '#FF6B0B' }}
                floatingLabelStyle={floatingLabelStyleSettings}
                floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
                type={type}
                errorText={error}
                maxLength={max}

                onChange={(event) => { input.onChange(event); }}
            />
        </MuiThemeProvider>
    );
};

class ConfirmaContrasenia extends React.Component {

    errorPassword = false;
    msjerror = "Campo Requerido"
    state = {
        showPass: false,
        showTooltip: false,
        mensaje: "",
        type: "",
        titulo: "",
        showPassActual: true,
        errorRequeridoContraActual: false,
    }

    muestraTooltip = (show, type?, titulo?, mensaje?) => {
        setTimeout(() => {
            this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
        }, 300);
    }

    toggle = (sParam) => {
        this.setState({ [sParam]: !this.state[sParam] });
    }

    cancelar = (sRuta) => {
        this.props.pasoAnterior();
    }

    handleChangePass = e => {
        const { value } = e.target
        console.log();
        this.props.guardarPassword(e.target.value)

        if (value === "") {
            this.errorPassword = true;
        } else {
            this.errorPassword = false;
        }
    }

    handleBlur = e => {
        const { value } = e.target
        this.props.guardarPassword(value)
    }

    siguiente = values => {
        if (this.props.password === "") {
            this.errorPassword = true;
        } else {
            this.errorPassword = false;
        }
    }

    whatIWantToRunOnSubmit = values => {
        if (this.props.password !== "") {
            this.props.onSubmit({ ...values });
        }
    }

    cierraTooltip = e => {
        this.setState({
            showTooltip: !this.state.showTooltip
        });
    }

    viewPassActual = () => {
        this.setState({ showPassActual: !this.state.showPassActual });
    }

    render() {
        const { handleSubmit } = this.props;
        return (
            <form onSubmit={handleSubmit(this.whatIWantToRunOnSubmit)}>
                <ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
                    show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
                </ModalSintillo>
                <div className="div-elimina-cuenta" style={{height: "450px" }}>
                    <div className="txt-center">
                        <div id="title-Registro" className="div-titulo-eliminar">
                            <span className="material-icons bi bi-arrow-left"
                                style={{ float: "left", cursor: "pointer", marginTop: "20px" }}
                                onClick={this.cancelar.bind(this, "eliminar-cuenta")}>
                                arrow_back
                            </span>
                            <label id="txt-titulo-eliminar">Eliminar cuenta</label>
                            <br />
                            <hr className="label-hr" />
                        </div>
                        <div className="contenedor-opciones">

                            <div className="subtitulo">
                                <h1>Completa los siguientes datos </h1>
                            </div>
                            <div className="titulo-pass">
                                Escribe tu contraseña
                            </div>

                            <div className="col-md-9 marginLeft-cambioPass marginLeft-cambioPass-2">
                                <div className='row' style={{ width: '100%' }}>
                                    <div className="col-md-6" id="campo-password-cambiaPassword">
                                        <Field
                                            name="password" id="pass" label="Contraseña" component={campo} max="24" type={this.state.showPassActual ? "password" : "text"}
                                            props={{ param: this.state.showPassActual, fnToggle: this.toggle.bind(this, "showPassActual") }}
                                            error={this.state.errorRequeridoContraActual ? campoRequ : null}
                                            onBlur={this.handleBlur}
                                        />
                                        <button type="button" className={this.state.showPassActual ? ojito : ojitoCerrado} onClick={() => { this.viewPassActual() }}></button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6" style={{ marginLeft: "25%", marginBottom: "10px" }}>
                                <button id="btn-continuar-cambioPass"
                                    style={{ width: '120px', height: '48px', fontSize: '16px', padding: '14px 16px' }}
                                    className="orange-rectangle" onClick={this.siguiente}>Continuar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form >
        );
    }
}

ConfirmaContrasenia = reduxForm({ form: "contrasenia" })(ConfirmaContrasenia);
export default connect(mapState, mapDispatch)(ConfirmaContrasenia);


// WEBPACK FOOTER //
// ./src/miPerfil/confirmaContrasenia.frm.js